import { ProjectType } from '@/features/apiSliceWithProjects'
import { useSearchParams } from 'react-router'

export default function useProjectType(): ProjectType {
  const [searchParams] = useSearchParams()
  const value = searchParams.get('projectType')
  return Object.values(ProjectType).includes(value as ProjectType)
         ? value as ProjectType
         : ProjectType.Invited
}
